import { useAppSelector } from 'lib/hooks/redux';
import { useSiteMapQuery } from 'lib/hooks/queries';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const Legend = ({ isMobileView }: { isMobileView?: boolean }) => {
  // Redux Hooks and States
  const { legends } = useAppSelector((state) => ({
    legends: state.siteMap.legends,
  }));

  // Get Site Map Data from React-Query Cache (No Params)
  const siteMapData = useSiteMapQuery().data!;
  // Semantic Vars From Site Map Data
  const {
    displayOptions: [{ legendPosition }],
  } = siteMapData;

  // React Hooks
  const [positionStyles, setPositionStyles] = useState('');

  useEffect(() => {
    if (legendPosition === 'top') {
      setPositionStyles(`
      width: 100%;
      top: ${isMobileView ? '52px' : '0'};
      left: 0;
      right: ${isMobileView ? '0' : Math.min(70, window.innerWidth / 10) + 'px'};
      `);
    } else if (legendPosition === 'left') {
      setPositionStyles(`
      width: 15vw;
      top: ${isMobileView ? '75px' : '20px'};
      left: 10px;
      flex-direction: column;
      gap: 5px;
      `);
    } else {
      setPositionStyles(`
      bottom: 0;
      left: 0;
      right: 0;
      `);
    }
  }, [legendPosition, isMobileView]);

  return (
    <StyledLegendBar positionStyles={positionStyles} data-cy="legend-bar">
      {Object.entries(legends).map(([label, color]) => (
        <StyledLegend
          key={label}
          leftPos={legendPosition === 'left'}
          color={color}
          data-cy="legend"
        >
          <label>{label}</label>
        </StyledLegend>
      ))}
    </StyledLegendBar>
  );
};

export default Legend;

const StyledLegendBar = styled.div<{
  positionStyles: string;
}>`
  position: absolute;
  z-index: 100;
  display: flex;
  ${({ positionStyles }) => positionStyles}
`;

const StyledLegend = styled.div<{
  leftPos: boolean;
  color: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  background: ${({ color }) => color};
  color: #fff;
  font-size: min(2.2vw, 16px);
  font-weight: 600;
  text-transform: uppercase;
`;
